import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
    static policy_id = "";
    static email_id = "";

    static coverage = 
    [
        {
          id: 1,
          title:'PROPERTY COVERAGE',
          subtitle: 'Protects your business operations & physical property',
          icon: '../../../../assets/icons/PropertyCoverage.svg',
          coverage: '150,000',
          initial_coverage :'150,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000',
            max: '275,000'
          },
          counter:  false,
          counterLabel: '',
          switch: 1,
          slider_value : 50
        },
       
        {
          id: 2,
          title:'ACCIDENT COVERAGE',
          subtitle: 'Protects your employees for work related accidents',
          icon: '../../../../assets/icons/AccidentCoverage.svg',
          coverage: '25,000',
          initial_coverage: '25,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'10,000',
            max: '40,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 3,
          title:'VEHICLE & DRIVER COVERAGE',
          subtitle: 'Protects your business vehicles and employees driving for your business',
          icon: '../../../../assets/icons/DriverCoverage.svg',
          coverage: '60,000',
          initial_coverage: '60,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '95,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 4,
          title:'GOODS/CARGO COVERAGE',
          subtitle: 'Protects your goods in your vehicles / trucks',
          icon: '../../../../assets/icons/GoodsCoverage.svg',
          coverage: '50,000',
          initial_coverage: '50,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '75,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 5,
          title:'DATA COVERAGE',
          subtitle: "Protects your data & customer's info",
          icon: '../../../../assets/icons/DataCoverage.svg',
          coverage: '200,000',
          initial_coverage: '200,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '375,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 6,
          title: 'LIABILITY COVERAGE',
          subtitle: 'Protects your company & employees from adverse work related scenarios',
          icon: '../../../../assets/icons/LiablityCoverage.svg',
          coverage: '50,000',
          initial_coverage: '50,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '75,000'
          },
          switch: 1,
          slider_value : 50
        },
    ]

    public original_coverage = [
        {
          id: 1,
          title:'PROPERTY COVERAGE',
          subtitle: 'Protects your business operations & physical property',
          icon: '../../../../assets/icons/PropertyCoverage.svg',
          coverage: '150,000',
          initial_coverage :'150,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000',
            max: '275,000'
          },
          counter:  false,
          counterLabel: '',
          switch: 1,
          slider_value : 50
        },
       
        {
          id: 2,
          title:'ACCIDENT COVERAGE',
          subtitle: 'Protects your employees for work related accidents',
          icon: '../../../../assets/icons/AccidentCoverage.svg',
          coverage: '25,000',
          initial_coverage: '25,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'10,000',
            max: '40,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 3,
          title:'VEHICLE & DRIVER COVERAGE',
          subtitle: 'Protects your business vehicles and employees driving for your business',
          icon: '../../../../assets/icons/DriverCoverage.svg',
          coverage: '60,000',
          initial_coverage: '60,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '95,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 4,
          title:'GOODS/CARGO COVERAGE',
          subtitle: 'Protects your goods in your vehicles / trucks',
          icon: '../../../../assets/icons/GoodsCoverage.svg',
          coverage: '50,000',
          initial_coverage: '50,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '75,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 5,
          title:'DATA COVERAGE',
          subtitle: "Protects your data & customer's info",
          icon: '../../../../assets/icons/DataCoverage.svg',
          coverage: '200,000',
          initial_coverage: '200,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '375,000'
          },
          switch: 1,
          slider_value : 50
        },
        {
          id: 6,
          title: 'LIABILITY COVERAGE',
          subtitle: 'Protects your company & employees from adverse work related scenarios',
          icon: '../../../../assets/icons/LiablityCoverage.svg',
          coverage: '50,000',
          initial_coverage: '50,000',
          price: 0.0,
          initial_price: 0.0,
          range: {
            min:'25,000 ',
            max: '75,000'
          },
          switch: 1,
          slider_value : 50
        },
    ];
    static filtered_coverage = CommonService.coverage;


    static coverage_total = 0;
    static filtered_total = 0;
    static coverage_options_selected = [1,2,3,4,5,6];
    private headerSource = new BehaviorSubject('');
    private headerLeftIcon = new BehaviorSubject('../../../assets/icons/menu.svg');
    private coverageOptions = new BehaviorSubject([]);
    private coverageTotal = new BehaviorSubject(CommonService.coverage_total);
    private coverageOptionsAll = new BehaviorSubject(CommonService.coverage);
    
    currentHeader = this.headerSource.asObservable();
    currentHeaderLeftIcon = this.headerLeftIcon.asObservable();
    currentOptions = this.coverageOptions.asObservable();
    currentCoverageTotal = this.coverageTotal.asObservable();
    currentAllCoverage = this.coverageOptionsAll.asObservable();
    constructor() { }


    changeHeaderLeftIcon(header_image: string){
      this.headerLeftIcon.next(header_image);
    }
    changeHeader(header: string) {
        this.headerSource.next(header)
    }
    isResponsive() {
        return window.screen.width < 767
    }

    changeOptions(options)
    {
        this.coverageOptions.next(options);
    }
    changeAllCoverage(options)
    {
        this.coverageOptionsAll.next(options);
    }
    changeTotalCoverage(total){
        this.coverageTotal.next(total);
    
    }
    static filer_coverage_values()
    {
        CommonService.filtered_coverage = [];
        for(let i=0; i<CommonService.coverage_options_selected.length; i++)
        {
            for(let j=0; j<6;j++)
            {
                if(CommonService.coverage[j] != null)
                  if(CommonService.coverage[j]["id"] == CommonService.coverage_options_selected[i])
                  {
                      CommonService.filtered_coverage.push(CommonService.coverage[j]);
                  }
            }
        }
        CommonService.total_filtered_values()
        // console.log('calling total')
        // CommonService.total_filtered_values()

        // console.log(CommonService.filtered_coverage);
    }
    static total_filtered_values(){
      var total = 0
      // console.log("before total", CommonService.filtered_coverage);
      for(let i = 0; i<CommonService.filtered_coverage.length;i++)
      {
          total+= CommonService.filtered_coverage[i]['price']

      }
      total = +total.toFixed(2);
      // console.log('total:',total);

      CommonService.filtered_total  = total;
    }

    static calculatePrice(){
      for(let i = 0; i<CommonService.coverage.length; i++){
        CommonService.coverage[i]['price'] = +((CommonService.coverage[i]['coverage']+"").replace(",","")) * CommonService.coverage[i]['initial_price']/(+CommonService.coverage[i]['range']['min'].replace(",",""));
      }
    }

    static setToInitialCoverage(){
      for(let i = 0; i<CommonService.coverage.length; i++){
        CommonService.coverage[i]['price'] = CommonService.coverage[i]['initial_price'];
        CommonService.coverage[i]['coverage'] = CommonService.coverage[i]['initial_coverage'];
      } 
    }

    static removeUnwantedCoverages(commonService){
      CommonService.coverage_options_selected = [];
      var coverageOptionsToDelete = []
      // console.log(CommonService.coverage);
      for(let i=0;i<CommonService.coverage.length; i++){
        if(CommonService.coverage[i]['price'] != 0 && CommonService.coverage[i]['price']+"" != "NaN"){
            CommonService.coverage_options_selected.push(CommonService.coverage[i]['id']);
            // console.log(CommonService.coverage[i]['price'], CommonService.coverage[i]['id'])
            
          }else{
            // CommonService.deleteFromCoverageAll(CommonService.coverage[i]['id']);
            coverageOptionsToDelete.push(CommonService.coverage[i]['id'])
          }
        }
      for(let i=0; i<coverageOptionsToDelete.length; i++){
        CommonService.deleteFromCoverageAll(coverageOptionsToDelete[i]);
      }
      commonService.changeOptions(CommonService.filtered_coverage);
      commonService.changeTotalCoverage(CommonService.filtered_total);
    }

    static deleteFromCoverageAll(id){
      var temp_coverage = []
      for(let i = 0; i<CommonService.coverage.length; i++){
        if(CommonService.coverage[i]['id'] == id){

        }
        else{
          temp_coverage.push(CommonService.coverage[i]);
        }
      }

      // console.log("updated coverage", temp_coverage);
      CommonService.coverage = temp_coverage;
    }
}
